export const interviewDataActionTypes = {
  SET_INTERVIEW_DATA: 'SET_INTERVIEW_DATA',
  SET_DAY_NAME: 'SET_DAY_NAME',
};
